import React from 'react';

const RecipientSourceToggle = ({ formData, handleInputChange, isDark }) => {
    const options = [
        { value: 'strata', label: 'Strata Master Recipients' },
        { value: 'non-strata', label: 'Non-Strata Recipients' }
    ];

    return (
        <div
            className={`rounded-[16px] p-[20px] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] ${
                isDark ? 'bg-[#000000]' : 'bg-white'
            }`}
        >
            <label className={`font-semibold text-[16px] leading-[21px] transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`} style={{ fontFamily: 'DM Sans' }}>
                Recipient Source <span className="text-[#FF0000]">*</span>
            </label>

            <div className="flex flex-row gap-[16px]">
                {options.map((option) => (
                    <button
                        key={option.value}
                        type="button"
                        onClick={() => handleInputChange('recipientSource', option.value)}
                        className={`flex-1 py-[12px] px-[16px] rounded-[8px] font-medium text-[14px] transition-all duration-200 border-solid border-[1px] ${
                            formData.recipientSource === option.value
                                ? isDark
                                    ? 'bg-[#cd6d2c] border-[#cd6d2c] text-[#000000]'
                                    : 'bg-[#cd6d2c] border-[#cd6d2c] text-white'
                                : isDark
                                    ? 'bg-[#161515] border-[#292929] text-[#b3b3b3] hover:border-[#cd6d2c]'
                                    : 'bg-[#f5f5f5] border-[#f8f9fa] text-[#686868] hover:border-[#cd6d2c]'
                        }`}
                    >
                        {option.label}
                    </button>
                ))}
            </div>

            {formData.recipientSource === 'non-strata' && (
                <p className={`text-[14px] font-normal m-0 transition-colors duration-200 ${
                    isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
                }`}>
                    For external recipients not in Strata Master. Only document upload, email address, and recipient details (name + postal) are required.
                </p>
            )}
        </div>
    );
};

export default RecipientSourceToggle;
